<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?(viewShow?'查看':'编辑推送'):'新增推送'" :visible.sync="dialog" @close="unShowClick()"
			width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="推送标题" prop="title" :label-width="formLabelWidth">
					<el-input :disabled='viewShow' style="width: 100%;" v-model="addBody.title"
						placeholder="请输入推送标题"></el-input>
				</el-form-item>
				<el-form-item label="推送分类" prop="type" :label-width="formLabelWidth">
					<el-radio-group :disabled='viewShow' v-model="addBody.type">
						<el-radio :label="1">纯文本</el-radio>
						<el-radio :label="2">关联课程</el-radio>
						<el-radio :label="3">关联培训</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="推送内容" prop="content" :label-width="formLabelWidth">
					<el-input :disabled='viewShow' style="width: 100%;" v-model="addBody.content" type="textarea"
						:rows='5' placeholder="请输入推送内容"></el-input>
				</el-form-item>
				<el-form-item label="选择课程" v-if="addBody.type == 2" :label-width="formLabelWidth">
					<el-select :disabled='viewShow' style="width: 100%;" v-model="addBody.course_uuid"
						placeholder="请选择">
						<el-option v-for="item in courseList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择培训" v-if="addBody.type == 3" :label-width="formLabelWidth">
					<el-select :disabled='viewShow' style="width: 100%;" v-model="addBody.train_uuid" placeholder="请选择">
						<el-option v-for="item in trainList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="推送类型" prop="user_type" :label-width="formLabelWidth">
					<el-select :disabled='viewShow' style="width: 100%;" v-model="addBody.user_type" placeholder="请选择">
						<el-option v-for="item in userListType" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择用户" v-if="addBody.user_type == 1" :label-width="formLabelWidth">
					<el-select :disabled='viewShow' style="width: 100%;" multiple v-model="addBody.user_uuid"
						placeholder="请选择">
						<el-option v-for="item in userList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择企业" v-if="addBody.user_type ==2" :label-width="formLabelWidth">
					<el-select :disabled='viewShow' style="width: 100%;" v-model="addBody.business_uuid"
						placeholder="请选择">
						<el-option v-for="item in businessList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="推送时间" prop="push_time" :label-width="formLabelWidth">
					<el-date-picker value-format='yyyy-MM-dd HH:mm:ss' :disabled='viewShow' style="width: 100%;"
						v-model="addBody.push_time" type="datetime" placeholder="选择日期时间">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer" v-if="!viewShow">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="putMsgPush('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addMsgPush,
		putMsgPush,
		getUser
	} from '@/api/marketing'
	import {
		getTrainList
	} from '@/api/train'
	import {
		getCourseList
	} from '@/api/course'
	import {
		getUserList,
		getBusinessList
	} from '@/api/user'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				userList: [],
				userListType: [{
						label: '个人用户',
						value: 1
					},
					{
						label: '企业用户',
						value: 2
					},
					{
						label: '全体用户',
						value: 3
					}
				],
				level: [],
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					content: '',
					title: '',
					uuid: '',
					type: 3,
					user_type: 1,
					push_time: '',
					business_uuid: '',
					user_uuid: [],
					course_uuid: '',
					train_uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}, ],
					content: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}, ],
					type: [{
						required: true,
						message: '请选择分类',
						trigger: 'blur'
					}, ],
					user_type: [{
						required: true,
						message: '请选择推送类型',
						trigger: 'blur'
					}, ],
					push_time: [{
						required: true,
						message: '请选择推送时间',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				],
				courseList: [],
				trainList: [],
				businessList: [],
				viewShow: false,
			}
		},
		mounted() {
			this.getTrainList()
			this.getCourseList()
			this.getBusinessList()
			this.getUserList()
		},
		methods: {
			async getBusinessList() {
				const {
					status,
					data
				} = await getBusinessList({
					page_index: 1,
					page_size: 9999
				})
				this.businessList = data.result.data
			},
			async getUserList() {
				const {
					status,
					data
				} = await getUserList({
					page_index: 1,
					page_size: 9999
				})
				this.userList = data.result.data
			},
			async getTrainList() {
				const {
					status,
					data
				} = await getTrainList({
					page_index: 1,
					page_size: 9999
				})
				this.trainList = data.result.data
			},
			async getCourseList() {
				const {
					status,
					data
				} = await getCourseList({
					page_index: 1,
					page_size: 9999
				})
				this.courseList = data.result.data
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			putMsgPush(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().putMsgPush()
						} else {
							this.network().addMsgPush()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.viewShow = false
				this.isEdit = false
				this.$emit('input', false)
			},
			network() {
				return {
					addMsgPush: async () => {
						const {
							status,
							data
						} = await addMsgPush({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					putMsgPush: async () => {
						const {
							status
						} = await putMsgPush({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.viewShow = val.viewShow
					this.addBody.business_uuid = val.business_uuid
					this.addBody.course_uuid = val.course_uuid
					this.addBody.content = val.content
					this.addBody.title = val.title
					this.addBody.uuid = val.uuid
					this.addBody.type = val.type
					this.addBody.user_type = val.user_type
					this.addBody.push_time = val.push_time
					this.addBody.train_uuid = val.train_uuid
					this.addBody.user_uuid = val.user_uuid
				} else {
					this.addBody.business_uuid = ''
					this.addBody.course_uuid = ''
					this.addBody.content = ''
					this.addBody.title = ''
					this.addBody.uuid = ''
					this.addBody.type = ''
					this.addBody.user_type = ''
					this.addBody.push_time = ''
					this.addBody.train_uuid = ''
					this.addBody.user_uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>